
import { defineComponent, PropType } from 'vue'
import { PackageManager, VulnerabilityOccurrenceFixability } from '~/types/types'
import { getPackageManagerIcon } from '~/utils/dependencies'
import { getBackRoute } from '~/utils/router'

export interface VCSLink {
  type: 'pullRequest' | 'commit'
  url: string
}

export default defineComponent({
  name: 'OccurrenceHeader',
  props: {
    target: {
      type: String,
      default: ''
    },
    packageManager: {
      type: String as PropType<PackageManager>,
      default: ''
    },
    showFixButton: {
      type: Boolean,
      default: true
    },
    vcsLink: {
      type: Object as PropType<VCSLink>,
      default: null
    },
    identifier: {
      type: String,
      required: true
    },
    fixability: {
      type: String as PropType<VulnerabilityOccurrenceFixability>,
      default: VulnerabilityOccurrenceFixability.Unfixable
    }
  },
  computed: {
    prevRoute() {
      return getBackRoute(this.$route, { referrer: this.$nuxt.context.from })
    },
    isAutofixable() {
      return this.fixability === VulnerabilityOccurrenceFixability.AutoFixable
    }
  },
  methods: {
    getPackageManagerIcon
  }
})
